/**
 * Clears all service worker registrations and caches, then reloads the page.
 * Used when stale chunks are detected after a deployment — the service worker
 * may be serving an old index.html that references chunk hashes that no longer
 * exist on the server.
 */
export function clearCachesAndReload(): void {
  void Promise.all([
    'serviceWorker' in navigator
      ? navigator.serviceWorker.getRegistrations().then((regs) => {
          for (const reg of regs) void reg.unregister();
        })
      : Promise.resolve(),
    'caches' in window
      ? caches.keys().then((names) => {
          for (const name of names) void caches.delete(name);
        })
      : Promise.resolve(),
  ]).finally(() => {
    window.location.reload();
  });
}
